module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-03-m-jp.6f7e48ffd2baf5db98fc3affd0ee17f5.png";